import { LogoWidgetService } from './logo.widget.service';
import { Component, Input, OnChanges, SimpleChanges, OnInit } from '@angular/core';

@Component({
  selector: 'logo-widget',
  styleUrls: ['./logo.widget.scss'],
  template: `
    <img
      *ngIf="imgType === 'image' && resolvedImageUrl !== 'default_app_icon'"
      [ngClass]="styleInfo"
      [src]="resolvedImageUrl"
    />
    <div
      *ngIf="imgType !== 'image' || resolvedImageUrl === 'default_app_icon'"
      [ngClass]="iconClass"
    >
      <mat-icon
        class="mdi cloud"
        [ngClass]="defaultUrl === 'default_app_icon' ? 'mdi-television-guide' : defaultUrl"
      ></mat-icon>
    </div>
  `
})
export class LogoWidgetComponent implements OnChanges, OnInit {
  @Input() defaultUrl: string;
  @Input() serviceUrl: string;
  @Input() styleInfo: string;
  //imageType can be material/image, default will be considered as image
  @Input() imgType? = 'image';
  @Input() iconClass?: string;
  resolvedImageUrl: string;
  logoWidgetService: LogoWidgetService;

  constructor(logoWidgetService: LogoWidgetService) {
    this.logoWidgetService = logoWidgetService;
  }

  ngOnInit(): void {
    this.resolvedImageUrl = this.defaultUrl;
    this.updateIcon(this.serviceUrl, this.defaultUrl);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['serviceUrl']) {
      this.updateIcon(changes.serviceUrl.currentValue, this.defaultUrl);
    }
    if (changes['defaultUrl']) {
      this.updateIcon(this.serviceUrl, changes.defaultUrl.currentValue);
    }
  }

  updateIcon(serviceUrl: string, defaultUrl: string): void {
    // only look up images for http services, otherwise return defaultUrl
    if (serviceUrl && serviceUrl.indexOf('tcp:') < 0) {
      this.logoWidgetService.getImage(serviceUrl, defaultUrl, (originalUrl, imgData) => {
        if (this.serviceUrl !== originalUrl) {
          // if your input to logo.widget is bound to rapidly updating input value, sometimes you will get
          // responses from backend in incorrect order (since they are coming back asynchronously!)
          return;
        }
        this.resolvedImageUrl = imgData;
      });
    } else {
      this.resolvedImageUrl = defaultUrl;
    }
  }
}
